import { AidaService } from '@adaptiva/ai/common';
import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, provideBaseWidget } from '@adaptiva/core/widgets';
import { BrandingService } from '@adaptiva/data-service';
import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { IProductTrialDisplay } from './interfaces';
import IMPORTS from './llm-free-trial-imports';
import { LlmFreeTrialComponentService } from './llm-free-trial.component.service';

@Component({
	selector: 'ada-llm-free-trial',
	templateUrl: './llm-free-trial.component.html',
	styleUrl: './llm-free-trial.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		LlmFreeTrialComponentService,
		provideBaseWidget(() => LlmFreeTrialComponent),
	],
	imports: IMPORTS,
	host: {
		'[class.ada-full-height]': 'true',
	}
})
export class LlmFreeTrialComponent extends BaseWidgetComponent {

	protected readonly aida: AidaService = inject(AidaService);

	protected readonly branding: BrandingService = inject(BrandingService);

	protected readonly ui: UiService = inject(UiService);

	protected readonly llmTrial: LlmFreeTrialComponentService = inject(LlmFreeTrialComponentService);

	protected readonly selectedSkus: WritableSignal<string[]> = signal([]);

	protected toggleSku(_product: IProductTrialDisplay, _isSelected: boolean): void {
		this.selectedSkus.update((_skus: string[]) => {
			if (_isSelected)
				return _skus.concat(_product.skuName);
			else
				return _skus.filter(s => s !== _product.skuName);
		});
	}

	protected onSubmitButtonClicked(): void {
		this.llmTrial.submit(this.selectedSkus()).pipe(this.takeOneUntilDestroyed()).subscribe({
			next: (): void => {
				this.selectedSkus.set([]);
			}
		});
	}

}
